import { Badge } from '@mui/material'

const TabNotificationBudge: RFC<{ invisible?: boolean }> = ({
  children,
  invisible
}) => {
  return (
    <Badge
      variant="dot"
      invisible={invisible}
      color="secondary"
      sx={{
        '.MuiBadge-badge': {
          right: -2,
          width: 14,
          height: 14
        }
      }}
    >
      {children}
    </Badge>
  )
}

export default TabNotificationBudge
